import {
  AlertCircle as AlertCircleGlyph,
  AlertTriangle as AlertTriangleGlyph,
  ArrowLeft as ArrowLeftGlyph,
  Award as AwardGlyph,
  BarChart3 as BarChart3Glyph,
  BookOpen as BookOpenGlyph,
  Building as BuildingGlyph,
  Calendar as CalendarGlyph,
  CheckCircle2 as CheckCircleGlyph,
  Clock as ClockGlyph,
  Crown as CrownGlyph,
  Database as DatabaseGlyph,
  Download as DownloadGlyph,
  Edit3 as Edit3Glyph,
  Eye as EyeGlyph,
  EyeOff as EyeOffGlyph,
  FileText as FileTextGlyph,
  GraduationCap as GraduationCapGlyph,
  Heart as HeartGlyph,
  Home as HomeGlyph,
  LogOut as LogOutGlyph,
  MapPin as MapPinGlyph,
  Menu as MenuGlyph,
  Phone as PhoneGlyph,
  PieChart as PieChartGlyph,
  Plus as PlusGlyph,
  Printer as PrinterGlyph,
  RefreshCw as RefreshCwGlyph,
  Search as SearchGlyph,
  Settings as SettingsGlyph,
  Shield as ShieldGlyph,
  Sparkles as SparklesGlyph,
  Star as StarGlyph,
  Trash2 as Trash2Glyph,
  TreePine as TreePineGlyph,
  TrendingUp as TrendingUpGlyph,
  Upload as UploadGlyph,
  User as UserGlyph,
  UserCheck as UserCheckGlyph,
  UserPlus as UserPlusGlyph,
  Users as UsersGlyph,
  X as XGlyph,
} from 'lucide-react';

const ICON_COLORS = 'primary:#176d37,secondary:#d3ad4d';

const ICON_COMPONENTS = {
  AlertCircle: AlertCircleGlyph,
  AlertTriangle: AlertTriangleGlyph,
  ArrowLeft: ArrowLeftGlyph,
  Award: AwardGlyph,
  BarChart3: BarChart3Glyph,
  BookOpen: BookOpenGlyph,
  Building: BuildingGlyph,
  Calendar: CalendarGlyph,
  CheckCircle: CheckCircleGlyph,
  Clock: ClockGlyph,
  Crown: CrownGlyph,
  Database: DatabaseGlyph,
  Download: DownloadGlyph,
  Edit3: Edit3Glyph,
  Eye: EyeGlyph,
  EyeOff: EyeOffGlyph,
  FileText: FileTextGlyph,
  GraduationCap: GraduationCapGlyph,
  Heart: HeartGlyph,
  Home: HomeGlyph,
  LogOut: LogOutGlyph,
  MapPin: MapPinGlyph,
  Menu: MenuGlyph,
  Phone: PhoneGlyph,
  PieChart: PieChartGlyph,
  Plus: PlusGlyph,
  Printer: PrinterGlyph,
  RefreshCw: RefreshCwGlyph,
  Search: SearchGlyph,
  Settings: SettingsGlyph,
  Shield: ShieldGlyph,
  Sparkles: SparklesGlyph,
  Star: StarGlyph,
  Trash2: Trash2Glyph,
  TreePine: TreePineGlyph,
  TrendingUp: TrendingUpGlyph,
  Upload: UploadGlyph,
  User: UserGlyph,
  UserCheck: UserCheckGlyph,
  UserPlus: UserPlusGlyph,
  Users: UsersGlyph,
  X: XGlyph,
};

function getPrimaryColor(colors) {
  const match = String(colors || '').match(/primary:([^,]+)/);
  return match?.[1] || '#176d37';
}

function LordIconGlyph({ name, className = '', size = 20, trigger = 'hover', colors = ICON_COLORS, ...rest }) {
  const IconComponent = ICON_COMPONENTS[name] || StarGlyph;

  return (
    <IconComponent
      size={size}
      strokeWidth={2}
      color={getPrimaryColor(colors)}
      className={className}
      aria-hidden="true"
      {...rest}
    />
  );
}

const makeIcon = (name) => function IconComponent(props) {
  return <LordIconGlyph name={name} {...props} />;
};

export const AlertCircle = makeIcon('AlertCircle');
export const AlertTriangle = makeIcon('AlertTriangle');
export const ArrowLeft = makeIcon('ArrowLeft');
export const Award = makeIcon('Award');
export const BarChart3 = makeIcon('BarChart3');
export const BookOpen = makeIcon('BookOpen');
export const Building = makeIcon('Building');
export const Calendar = makeIcon('Calendar');
export const CheckCircle = makeIcon('CheckCircle');
export const Clock = makeIcon('Clock');
export const Crown = makeIcon('Crown');
export const Database = makeIcon('Database');
export const Download = makeIcon('Download');
export const Edit3 = makeIcon('Edit3');
export const Eye = makeIcon('Eye');
export const EyeOff = makeIcon('EyeOff');
export const FileText = makeIcon('FileText');
export const GraduationCap = makeIcon('GraduationCap');
export const Heart = makeIcon('Heart');
export const Home = makeIcon('Home');
export const LogOut = makeIcon('LogOut');
export const MapPin = makeIcon('MapPin');
export const Menu = makeIcon('Menu');
export const Phone = makeIcon('Phone');
export const PieChart = makeIcon('PieChart');
export const Plus = makeIcon('Plus');
export const Printer = makeIcon('Printer');
export const RefreshCw = makeIcon('RefreshCw');
export const Search = makeIcon('Search');
export const Settings = makeIcon('Settings');
export const Shield = makeIcon('Shield');
export const Sparkles = makeIcon('Sparkles');
export const Star = makeIcon('Star');
export const Trash2 = makeIcon('Trash2');
export const TreePine = makeIcon('TreePine');
export const TrendingUp = makeIcon('TrendingUp');
export const Upload = makeIcon('Upload');
export const User = makeIcon('User');
export const UserCheck = makeIcon('UserCheck');
export const UserPlus = makeIcon('UserPlus');
export const Users = makeIcon('Users');
export const X = makeIcon('X');
